import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationDot, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { styles } from '../../styles'
import PropTypes from 'prop-types'

const Footer = () => {
  return (
    <footer className='text-[#f5f5f5] py-[50px] px-0 bg-primary border-t border-secondary'>
      <div className={`${styles.paddingX} max-w-7xl mx-auto relative z-0`}>
        <div className={styles.rowResponsive}>
          <div className='col-6'>
            <ul className='list-none p-0 m-0'>
              <ListItem icon={faLocationDot} text='Online Business, GA, USA' />
              <ListItem icon={faPhone} text='470-222-6001' />
              <ListItem icon={faEnvelope} text='support@perilousgames.com' link='mailto:support@perilousgames.com' />
            </ul>
            <ul className='list-none p-0 m-0 flex gap-x-5'>
              <li>
                <a href='https://www.facebook.com/share/1AHaWexAP3' aria-label='Facebook icon'>
                  <FontAwesomeIcon icon={faFacebook} className={styles.socialIcon} />
                </a>
              </li>
              <li>
                <a href='https://www.twitter.com' aria-label='Twitter icon'>
                  <FontAwesomeIcon icon={faTwitter} className={styles.socialIcon} />
                </a>
              </li>
              <li>
                <a href='https://www.instagram.com' aria-label='Instagram icon'>
                  <FontAwesomeIcon icon={faInstagram} className={styles.socialIcon} />
                </a>
              </li>
              <li>
                <a href='https://www.linkedin.com/company/perilous-games' aria-label='LinkedIn icon'>
                  <FontAwesomeIcon icon={faLinkedin} className={styles.socialIcon} />
                </a>
              </li>
            </ul>
          </div>
          <div className='flex justify-end'>
            <p className={`${styles.sectionSubText} text-right`}>
              &copy; 2017-2025 Perilous Games, Ltd. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

const ListItem = ({ icon, text, link = null }) => (
  <li className=''>
    {link
      ? (
        <a href={link ?? '#'} aria-label={text} className='sm:text-[18px] text-[16px] text-secondary flexCenter mb-3 gap-x-2'>
          {icon && <FontAwesomeIcon icon={icon} />}
          {text}
        </a>
        )
      : (
        <span className='sm:text-[18px] text-[16px] text-secondary flexCenter mb-3 gap-x-2'>
          {icon && <FontAwesomeIcon icon={icon} />}
          {text}
        </span>
        )}
  </li>
)

ListItem.propTypes = {
  icon: PropTypes.object,
  text: PropTypes.string,
  link: PropTypes.string
}

export default Footer
